import { gql } from '@apollo/client/core'

import { ATTRIBUTE_FRAGMENT } from './attribute'

export const EVENTS_FRAGMENT = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment Event on Event {
    id
    name
    slug
    visibility
    createdAt
    description
    dateStart
    dateEnd
    exclusive
    registrationStart
    registrationEnd
    status
    eventTypes {
      ...Attribute
    }
    eventAttributes {
      ...Attribute
    }
    gallery
    galleryPaths
    averageRating
    spotsRemaining
    startTime
    startType,
    purchaseType,
    club {
      ... on GetClubOutput {
        club {
          id
          slug
          clubName
          activated
          logo
          addressGeom {
            lat
            lon
          }
          city
          admissionTypes {
            name
            id
            position
          }
          advancedEventBooking
          isNonGolf
        }
      }
    }
    createdByPlayer {
      ... on GetUserOutput {
        user {
          id
          firstName
          lastName
        }
      }
    }
    availability
    memberDiscount
    advancedBookingWindow
    sponsors
    sponsorsPaths
    admissions {
      id
      price
      admissionType {
        ... on GetAdmissionTypeOutput {
          admissionType {
            id
            name
            defaultGreenFee
            position
          }
        }
      }
    }
    isNonGolf
    customAttributes
    startDateDescription
    startTimeDescription
    externalPriceRange
    externalPriceRangeDescription
    externalPurchaseLink
    archived
  }
`
